import React from 'react'
import { createPortal } from 'react-dom'
import cn from 'classnames'
import NewAnswerDndWrapper from 'components/answers/NewAnswerDndWrapper'
import { getCachedQuest, getCachedAnswer } from 'state/cache'
import { draftAnswerStore } from 'state/draftAnswerStore'
import NewAnswerOrig from 'components/answers/NewAnswer'
/** @type {React.ComponentType<any>} */
const NewAnswer = NewAnswerOrig
import QuestOptions from 'components/quests/QuestOptions'
import Perms from 'components/quests/Perms'
import PermsOptions from 'components/quests/PermsOptions'
import Connector from 'components/state/Connector'
import api from 'api/api'
import {
    recordChannelMembership,
    requestChannelJoin,
} from 'components/teams/ChannelJoinInviteModal'
import { membersOnlyPostReason } from 'state/channelJoinInvite'
import perms from 'lib/perms'
import { insertedAnswerPlaceholderParams } from 'lib/insertAnswerPlaceholder'
import { isMobile } from 'lib/device'
import AnswerDndContainer from 'components/answers/AnswerDndContainer'
import styles from './quest.module.scss'
import expandStyles from 'components/quests/Quest/expand-controls.module.scss'
import { isEqual, omitBy } from 'lodash'
import WithTooltip from 'components/shared/WithTooltip'
import { buildHoverTooltipAnchorProps } from 'components/shared/tooltipContract'
import domtoimage from 'dom-to-image'
import * as cache from 'state/cache'
import { assignActiveNewAnswerRef, assignSideNewAnswerRef } from 'state/imperativeApis/editorApi'
import questModel from 'components/quests/questModel'
import answerModel from 'components/answers/answerModel'
import useStore from 'state/knovStore'
import ErrorBoundary from 'components/shared/ErrorBoundary'
import {
    slideTo,
    slideNext,
    getCenterIndex,
    isPanelCenter,
    isPanelLeft,
    isPanelRight,
} from 'state/imperativeApis/swiperApi'
import useInsertLeft from 'refactor/hooks/useInsertLeft'
import { v4 as uuid } from 'uuid'
import useOpenRight from 'refactor/hooks/useOpenRight'
import useSlideToPanel from 'refactor/hooks/useSlideToPanel'
import usePanelContext from 'refactor/hooks/usePanelContext'
import { Link } from 'react-router-dom'
import ThinParent from './ThinParent'
import { fixedHeaderEnabled } from 'lib/fixedHeader'
import QuestAncestorSpine from './QuestAncestorSpine'
import { questHasAncestorSpine } from 'lib/scrollAncestors'
import { composerConnectorAnswerId, quoteMainEnabled } from 'lib/quoteMain'
import queryClient from 'api/queryClient'
import { getQuestsQueryKey } from 'refactor/hooks/api/useGetQuests'
import {
    removeQuestFromNaturalFeedSession,
    resetNaturalFeedSessionSnapshot,
} from 'lib/naturalFeedSession'
import {
    ArrowUp,
    AtSign,
    CornerUpLeft,
    Filter,
    Lock,
    Megaphone,
    Pin as PinIcon,
    UserPlus,
} from 'lucide-react'
import { getQuestReasonLabelGlyphKind } from 'lib/questReasonLabel'
import { QUEST_STREAM_REASON_LABEL_CHROME_PX } from 'lib/staticGeometryChrome'
import { withDepth } from 'components/filters/useStreamFilters'
import { getSwiperRef, SWIPE_SPEED_SLOW } from 'state/imperativeApis/swiperApi'
import { isUserMuted } from 'utils/muteUtils'
import MutedContentPlaceholder from 'components/shared/MutedContentPlaceholder'
import { clearPublishedNewThreadContext } from 'components/quests/newThreadDraftRecovery'
import { scheduleFirstReplyFocus } from 'components/quests/firstReplyFocus'
import { resolveQuestTitleNavigationTarget } from 'components/quests/questTitleNavigation'
import {
    resolveDirectMessageLatestAnswer,
    resolveQuestStreamPreviewAnswers,
} from 'lib/questStreamRenderedAnswers'
import { DirectMessageCardHeader } from 'components/panels/PanelPlaceBar'
import {
    preparePanelMediaHandoffToAnswer,
    resumePanelMediaHandoff,
} from 'components/panels/panelMediaPlayback'
import { lightweightStreamCardEnabled } from 'lib/lightweightThreadInStream'
import { bottomEditorEnabled } from 'lib/bottomEditor'
import {
    directMessageCounterpartId,
    directMessageRequestSide,
    directMessageRequestHasMessage,
    isDirectMessageQuest,
    isDirectMessageRoom,
} from 'lib/directMessages'
import { isDmChatQuest } from 'lib/dmChat'
import DirectMessageRequestBar, {
    DirectMessageRequestHint,
} from 'components/quests/DirectMessageRequestBar'
import {
    directMessageComposerPlaceholder,
    subscribeToDirectMessageCounterpart,
} from 'lib/directMessageComposer'
import {
    shouldNavigateQuestTitle,
    shouldShowQuestReplyArea,
} from 'components/panels/ordinalUpvalueFeature'

const stateSelector = (state, props) => {
    let quest = props.quest
    //quest = { ...quest, sorted_answers: quest.sorted_answers.map(a => state.answers[a.id]) }

    const serverMatches = props.quest.matching_answer_ids || []
    const clientMatches = quest.matching_answer_ids || []
    const hasClientMatches = clientMatches?.length > 0
    const hasServerMatches = serverMatches?.length > 0

    // The matching_answer_ids assignment will break shouldComponentUpdate's Object.is() check so only do it if there is a change to render.
    if (hasServerMatches && !isEqual(serverMatches, clientMatches)) {
        //console.log('NOT EQUAL', quest.matching_answer_ids, props.quest.matching_answer_ids)
        quest = { ...quest, matching_answer_ids: serverMatches }
    } else if (!hasServerMatches && hasClientMatches) {
        // Clear outdated view context attributes.
        quest = { ...quest, matching_answer_ids: [] }
    }

    const panel = props.panelContext?.panel
    const panelToLeft = state.panels?.getPanelToLeft(panel?.panelId)
    const isSelected = state.selectedAnswers[panelToLeft?.panelId]?.answerId === quest.parent?.id

    return {
        quest,
        selectedAnswer: state.selectedAnswer,
        middleFilter: state.middleFilter,
        globalAgentModel: state.questAgentModels[quest.id] || null,
        showAll:
            props.showAll ||
            (props.panel === 'middle'
                ? state.middlePanelExpandedQuests[props.quest.id]
                : state.rightPanelExpandedQuests[props.quest.id]),
        isSelected,
    }
}

const REASON_LABEL_GLYPHS = {
    mention: AtSign,
    reply: CornerUpLeft,
    upvalue: ArrowUp,
    follow: UserPlus,
    stream: Megaphone,
    filter: Filter,
}

function reasonLabelGlyph(label, notificationMessage) {
    const kind = getQuestReasonLabelGlyphKind(label, notificationMessage)
    return kind ? REASON_LABEL_GLYPHS[kind] : null
}

const CONTROL_BUTTONS = {
    perms: 'perms',
    filter: 'filter',
    sort: 'sort',
    edit: 'edit',
    search: 'search',
    tweet: 'tweet',
    blog: 'blog',
    export: 'export',
    delete: 'delete',
    crypto: 'crypto',
    play: 'play',
    copy: 'copy',
    collapse: 'collapse',
}

class Quest extends React.PureComponent {
    constructor(props) {
        super(props)

        this.SHOW_PREVIEW = 1
        this.SHOW_NEW = 3
        this.SHOW_MATCHING = 3
        this.bottomEditorPresence = false

        this.state = {
            questId: this.props.quest.id,
            questPublic: this.props.quest.public,
            questTeam: this.props.quest.team,
            edit: false,
            parentAnswerEditMode: false,
            showAll: this.props.showAll,
            collapseActivated: false,
            answersShown: 0,
            newSessionAnswers: [],
            revealMuted: false,
            questOptionsPosition: null,
            isReloadingQuest: false,
            // quote_main union: the head's main-thread quotes, fetched once
            // per branch open and interleaved with native replies.
            quoteAnswers: [],
            // A reply pill pressed on the trailing message quotes it in the
            // composer below instead of opening the modal. The seq lets a
            // second press re-offer a quote the reader had already refused.
            composerQuoteRequest: null,
            // What the composer reports it is actually quoting, refusal
            // included — the composer owns that answer, the thread only
            // mirrors it to decide whether the two rows are joined.
            composerQuoteTargetId: null,
        }

        this.ensureNewAnswer()
    }

    containerRef = React.createRef()
    parentAnswerRef = React.createRef()
    draftPermsRef = React.createRef()
    hydrationReloadTimeout = null
    hydrationReloadAttempts = 0
    lastHydrationGapSignature = null
    MAX_HYDRATION_RELOAD_ATTEMPTS = 2
    HYDRATION_RELOAD_DELAY_MS = 3000
    questOptionsPositionRaf = null
    questReloadInFlightCount = 0
    quoteAnswersFetchKey = null
    quoteAnswersRequestId = 0
    composerQuoteSeq = 0

    componentWillReceiveProps = nextProps => {
        if (this.props.showAll != nextProps.showAll && nextProps.showAll != this.state.showAll) {
            this.setState({ showAll: nextProps.showAll })
        }
    }

    collapseHandler = () => {
        const collapsePosition = this.props.quest.sorted_answers.reduce((a, b) =>
            a.position > b.position ? a : b,
        ).position

        this.setState({
            showAll: false,
            collapseActivated: true,
            answersShown: 0,
            collapsePosition: collapsePosition + 1,
        })
    }

    focusNewAnswer = timeout => {
        setTimeout(() => {
            this.newAnswer?.current?.focus()
        }, timeout || 100)
    }

    focusFirstReplyAfterPublish = () => {
        scheduleFirstReplyFocus(() => {
            const composer = this.newAnswer?.current
            if (!composer) return null

            return {
                isTitleComposer: !!composer.props?.isTitle,
                focus: () => composer.focus(),
            }
        })
    }

    componentDidMount = async () => {
        // Listen for quest cache updates (e.g., pin/unpin over sockets) and re-render
        this._onQuestUpdated = ev => {
            const updatedQuestId = ev?.detail?.questId
            const questId = this.props.quest?.id
            const quoteSourceQuestId = this.props.quest?.parent?.quest_id
            if (String(updatedQuestId) === String(questId)) {
                this.forceUpdate()
            }
            // The union's guest half changes when either the branch or the
            // room containing its head changes. Refetching also clears quotes
            // whose edge was severed by a cross-room move.
            if (
                updatedQuestId != null &&
                (String(updatedQuestId) === String(questId) ||
                    String(updatedQuestId) === String(quoteSourceQuestId))
            ) {
                this.maybeFetchQuoteAnswers({ force: true })
            }
        }
        window.addEventListener('quest_updated', this._onQuestUpdated)

        // Listen for draft modal close to refresh draft state from store
        this._onDraftModalClosed = ev => {
            if (ev?.detail?.questId === this.props.quest?.id) {
                this.forceUpdate()
            }
        }
        window.addEventListener('draft_modal_closed', this._onDraftModalClosed)

        if (this.props.activeMiddle && location.href.match(/\/new$/)) {
            // TODO HACK that we have to set a delay, but something is clobbering the focus before that...
            this.focusNewAnswer(2000)
        }

        if (this.props.shouldPlay) {
            useStore.getState().actions.modalActions.openStoryModal(this.props.quest)
        }

        this.scheduleHydrationReloadIfNeeded()
        this.maybeFetchQuoteAnswers()
        this.syncBottomEditorPresence()
        this.syncDirectMessageCounterpart()
    }

    // quote_main: a branch view is the union projection — native replies plus
    // the main-thread quotes of its head. Fetch the guest half once per branch
    // and source room, then refresh it when either quest changes.
    maybeFetchQuoteAnswers = async ({ force = false } = {}) => {
        const quest = this.props.quest
        if (!quoteMainEnabled() || !this.props.isActive) return
        if (!quest?.id || !quest?.parent?.quest_id) return
        const fetchKey = `${quest.id}:${quest.parent.quest_id}`
        if (!force && this.quoteAnswersFetchKey === fetchKey) return
        this.quoteAnswersFetchKey = fetchKey
        const requestId = ++this.quoteAnswersRequestId

        try {
            const answers = await api.getQuestQuotes(quest.id)
            if (requestId !== this.quoteAnswersRequestId || this.quoteAnswersFetchKey !== fetchKey)
                return
            this.setState({ quoteAnswers: answers || [] })
        } catch {
            // Leave the existing projection visible, but allow the next quest
            // update to retry instead of pinning a failed request forever.
            if (requestId === this.quoteAnswersRequestId) this.quoteAnswersFetchKey = null
        }
    }

    componentWillUnmount = () => {
        if (this.bottomEditorPresence) {
            this.bottomEditorPresence = false
            this.props.panelContext?.setBottomEditorMounted?.(false)
        }
        this.quoteAnswersRequestId += 1
        this.quoteAnswersFetchKey = null
        this.unsubscribeDirectMessageCounterpart?.()
        this.unsubscribeDirectMessageCounterpart = null
        if (this._onQuestUpdated) window.removeEventListener('quest_updated', this._onQuestUpdated)
        if (this._onDraftModalClosed)
            window.removeEventListener('draft_modal_closed', this._onDraftModalClosed)
        if (this.hydrationReloadTimeout) {
            clearTimeout(this.hydrationReloadTimeout)
            this.hydrationReloadTimeout = null
        }
        this.teardownQuestOptionsPositionTracking()
    }

    componentDidUpdate = (prevProps, prevState) => {
        this.ensureNewAnswer()
        this.syncBottomEditorPresence()
        this.syncDirectMessageCounterpart()
        function getDiff(oldProps, oldState, newProps, newState) {
            const propDiff = omitBy(newProps, (value, key) => Object.is(value, oldProps[key]))
            const stateDiff = omitBy(newState, (value, key) => Object.is(value, oldState[key]))
            return { props: propDiff, state: stateDiff }
        }
        const diff = getDiff(prevProps, prevState, this.props, this.state)
        //console.log('QUEST DIFF', diff)

        if (prevProps.quest?.id !== this.props.quest?.id) {
            this.hydrationReloadAttempts = 0
            this.lastHydrationGapSignature = null
            if (this.state.quoteAnswers.length) this.setState({ quoteAnswers: [] })
        }
        this.scheduleHydrationReloadIfNeeded()
        this.maybeFetchQuoteAnswers()

        const prevTrackingOpen = this.shouldTrackQuestOptionsPosition(prevState)
        const nextTrackingOpen = this.shouldTrackQuestOptionsPosition(this.state)

        if (!prevTrackingOpen && nextTrackingOpen) {
            this.setupQuestOptionsPositionTracking()
        } else if (prevTrackingOpen && !nextTrackingOpen) {
            this.teardownQuestOptionsPositionTracking()
        }
    }

    // "Hydration gap" = quest knows its answer IDs but the bulk fetch returned fewer than expected.
    getHydrationGap = (questArg = this.props.quest) => {
        const quest = questArg
        if (!quest) return null

        const expectedAnswerIds =
            quest.__knovAnswerHydrationScope === 'stream-preview' &&
            Array.isArray(quest.__knovStreamPreviewAnswerIds)
                ? quest.__knovStreamPreviewAnswerIds
                : quest.sorted_answer_ids
        const expectedCount = Array.isArray(expectedAnswerIds) ? expectedAnswerIds.length : 0
        const hydratedCount = (quest.sorted_answers || []).filter(Boolean).length
        const missingCount = Math.max(0, expectedCount - hydratedCount)
        const hasMissingParent = !!quest.parent_id && !quest.parent

        return {
            expectedCount,
            hydratedCount,
            missingCount,
            hasMissingParent,
            hasGap: missingCount > 0 || hasMissingParent,
        }
    }

    reloadQuest = async ({ reason = 'manual' } = {}) => {
        const quest = this.props.quest
        if (!quest?.id || quest?.is_draft) return false

        this.questReloadInFlightCount = this.questReloadInFlightCount + 1
        if (this.questReloadInFlightCount === 1) {
            this.setState({ isReloadingQuest: true })
        }

        let success = true
        try {
            // This must not share the in-flight preview query: TanStack would dedupe the
            // request and report preview completion as expansion success.
            await queryClient.cancelQueries({ queryKey: ['quest', quest.id], exact: true })
            // The server only honors break_cache for the quest owner or an admin.
            const canBreakCache =
                !!gon.currentUser &&
                (gon.currentUser.knov_admin || String(gon.currentUser.id) === String(quest.user_id))
            const fetchedQuest = await api.getQuest(
                quest.id,
                canBreakCache ? { break_cache: true } : {},
            )
            if (!fetchedQuest) throw new Error('Quest not found during reload')
            if (fetchedQuest.__knovAnswerHydrationScope !== 'full') {
                throw new Error('Quest reload completed without full thread hydration')
            }
        } catch (error) {
            success = false
            console.warn('>>> Quest.reloadQuest: failed to reload thread', {
                questId: quest.id,
                reason,
                error,
            })
        } finally {
            this.questReloadInFlightCount = Math.max(0, this.questReloadInFlightCount - 1)
            if (this.questReloadInFlightCount === 0) {
                this.setState({ isReloadingQuest: false })
            }
        }

        return success
    }

    // Auto-retry when a hydration gap is detected; capped to avoid infinite loops.
    scheduleHydrationReloadIfNeeded = () => {
        const quest = this.props.quest
        if (!quest?.id || quest?.is_draft) return

        const hydrationGap = this.getHydrationGap(quest)
        if (!hydrationGap?.hasGap) {
            this.hydrationReloadAttempts = 0
            this.lastHydrationGapSignature = null
            if (this.hydrationReloadTimeout) {
                clearTimeout(this.hydrationReloadTimeout)
                this.hydrationReloadTimeout = null
            }
            return
        }

        if (this.hydrationReloadAttempts >= this.MAX_HYDRATION_RELOAD_ATTEMPTS) return

        const gapSignature = [
            quest.id,
            hydrationGap.expectedCount,
            hydrationGap.hydratedCount,
            hydrationGap.hasMissingParent ? 'missing_parent' : 'parent_ok',
        ].join(':')

        if (this.lastHydrationGapSignature === gapSignature) return
        this.lastHydrationGapSignature = gapSignature

        if (this.hydrationReloadTimeout) clearTimeout(this.hydrationReloadTimeout)
        this.hydrationReloadTimeout = setTimeout(async () => {
            this.hydrationReloadTimeout = null
            const nextGap = this.getHydrationGap(this.props.quest)
            if (!nextGap?.hasGap) return

            this.hydrationReloadAttempts = this.hydrationReloadAttempts + 1
            console.warn('>>> Quest: reloading partially hydrated thread', {
                questId: quest.id,
                attempt: this.hydrationReloadAttempts,
                expectedCount: nextGap.expectedCount,
                hydratedCount: nextGap.hydratedCount,
                hasMissingParent: nextGap.hasMissingParent,
            })
            await this.reloadQuest({ reason: 'hydration_gap' })
        }, this.HYDRATION_RELOAD_DELAY_MS)
    }

    getQuestOptionsPosition = () => {
        const questEl = this.containerRef?.current
        if (!questEl) return null

        const rect = questEl.getBoundingClientRect()
        const viewportPadding = 12
        const top = Math.max(viewportPadding, rect.top)
        const left = Math.max(viewportPadding, rect.left)
        const width = Math.min(rect.width, window.innerWidth - viewportPadding * 2)
        const availableHeight = Math.max(220, window.innerHeight - top - viewportPadding)

        return {
            top,
            left,
            width,
            maxHeight: Math.min(availableHeight, window.innerHeight - viewportPadding * 2),
        }
    }

    getDraftPermsPosition = () => {
        const questEl = this.containerRef?.current
        const anchorEl = this.draftPermsRef?.current
        if (!questEl || !anchorEl || typeof window === 'undefined') return null

        const viewportPadding = 12
        const questRect = questEl.getBoundingClientRect()
        const anchorRect = anchorEl.getBoundingClientRect()
        const width = Math.min(
            Math.max(questRect.width - viewportPadding * 2, 280),
            window.innerWidth - viewportPadding * 2,
        )
        const left = Math.min(
            Math.max(questRect.left + viewportPadding, viewportPadding),
            window.innerWidth - viewportPadding - width,
        )
        const top = Math.max(viewportPadding, anchorRect.bottom + 8)
        const maxHeight = Math.max(220, window.innerHeight - top - viewportPadding)

        return {
            top,
            left,
            width,
            maxHeight,
        }
    }

    shouldTrackQuestOptionsPosition = state =>
        state.showQuestOptions || (this.isDraft() && state.showPermsOptions)

    getActiveQuestOptionsPosition = () => {
        if (this.isDraft() && this.state.showPermsOptions) {
            return this.getDraftPermsPosition()
        }

        return this.getQuestOptionsPosition()
    }

    updateQuestOptionsPosition = () => {
        const nextPosition = this.getActiveQuestOptionsPosition()
        if (!nextPosition) return

        this.setState(prevState => {
            const prev = prevState.questOptionsPosition
            if (
                prev &&
                prev.top === nextPosition.top &&
                prev.left === nextPosition.left &&
                prev.width === nextPosition.width &&
                prev.maxHeight === nextPosition.maxHeight
            ) {
                return null
            }
            return { questOptionsPosition: nextPosition }
        })
    }

    requestQuestOptionsPositionUpdate = () => {
        if (this.questOptionsPositionRaf) return
        this.questOptionsPositionRaf = window.requestAnimationFrame(() => {
            this.questOptionsPositionRaf = null
            this.updateQuestOptionsPosition()
        })
    }

    setupQuestOptionsPositionTracking = () => {
        this.updateQuestOptionsPosition()
        window.addEventListener('resize', this.requestQuestOptionsPositionUpdate)
        window.addEventListener('scroll', this.requestQuestOptionsPositionUpdate, true)
    }

    teardownQuestOptionsPositionTracking = () => {
        window.removeEventListener('resize', this.requestQuestOptionsPositionUpdate)
        window.removeEventListener('scroll', this.requestQuestOptionsPositionUpdate, true)
        if (this.questOptionsPositionRaf) {
            window.cancelAnimationFrame(this.questOptionsPositionRaf)
            this.questOptionsPositionRaf = null
        }
    }

    matchingAnswers = () => {
        const quest = this.props.quest
        const filtered = quest.sorted_answers.filter(ans =>
            quest.matching_answer_ids.includes(ans.id),
        )
        return filtered.sort(
            (a, b) =>
                quest.matching_answer_ids.indexOf(a.id) - quest.matching_answer_ids.indexOf(b.id),
        )
    }

    // What the composer quotes: only what the reader asked for. A reply pill
    // pressed on the trailing message pins its target here; with nothing
    // pinned the composer quotes nothing. It used to fall back to the reader's
    // own trailing message, offered unasked — answering yourself is usually a
    // continuation, but a quote nobody asked for read as a default to refuse,
    // so the press is now the only door.
    composerQuoteAnswer = () => {
        if (!quoteMainEnabled()) return null
        const requestedId = this.state.composerQuoteRequest?.answerId
        if (!requestedId) return null
        const pinned = this.displayAnswers().find(
            ans => ans && String(ans.id) === String(requestedId),
        )
        // Collapsing or filtering the thread can hide the selected row.
        // Keep its explicit target; NewAnswer hydrates the quote by ID.
        return pinned || { id: requestedId }
    }

    // The reply pill's in-place lane: the message is right there above the
    // composer, so quoting it needs no modal — the quote lands in the byline
    // and the gutter line joins the two rows. Focus follows, because pressing
    // reply is a request to start typing.
    quoteAnswerInComposer = answer => {
        if (!answer?.id) return
        this.composerQuoteSeq += 1
        this.setState({
            composerQuoteRequest: { answerId: String(answer.id), seq: this.composerQuoteSeq },
        })
        // A phone raises its keyboard only for a focus made inside the tap's
        // own gesture: a focus a timer later leaves the field focused with the
        // keyboard down. So the press focuses the field right here. A composer
        // that already has focus keeps it as it is: focusing it again put the
        // caret at the end, away from wherever the reader was writing.
        if (isMobile) {
            const composer = this.newAnswer?.current
            if (!composer?.composerHasFocus?.()) composer?.focusEditor?.({ defer: false })
        } else this.focusNewAnswer(0)
    }

    handleComposerQuoteTargetChange = answerId => {
        const next = answerId ? String(answerId) : null
        if (next === this.state.composerQuoteTargetId) return
        this.setState({ composerQuoteTargetId: next })
    }

    // The composer refused its quote: drop the pin here too, so a remount of
    // the composer cannot bring back a quote the reader turned down.
    clearComposerQuoteRequest = () => {
        if (this.state.composerQuoteRequest) this.setState({ composerQuoteRequest: null })
    }

    // Exactly the conditions the composer's own JSX below is nested under. The
    // reported quote target is a latch: NewAnswer stops reporting when it stops
    // existing, so anything that depends on the composer being THERE — the line,
    // the seam — has to re-derive that rather than trust the latch. Locking
    // replies mid-session unmounts the composer and would otherwise leave a line
    // running out of the last message into nothing.
    inlineComposerMounted = () =>
        !!(
            this.props.isActive &&
            this.showNewAnswer() &&
            gon.currentUser &&
            this.canCurrentUserReplyToQuest()
        )

    // Mounted is not the same as adjacent. A ranked thread hangs its expand strip
    // between the answer list and the composer, so the two are not neighbours and
    // there is no seam to join — the strip owns that boundary and keeps its own
    // border. Quoting from the composer still works there; it just does not draw
    // a line across an element that sits in the way.
    inlineComposerAdjacent = () =>
        this.inlineComposerMounted() && !(this.moreAnswers() > 0 && this.isRankedQuest())

    // Both ends of the composer's connector — and the seam border that gives way
    // to it — read this one value, so they can never disagree.
    connectedComposerAnswerId = () => {
        if (!this.inlineComposerAdjacent()) return null
        const answers = this.displayAnswers()
        return composerConnectorAnswerId({
            enabled: quoteMainEnabled(),
            quoteAnswerId: this.state.composerQuoteTargetId,
            lastAnswerId: answers[answers.length - 1]?.id,
        })
    }

    votedAnswers = () => questModel.votedAnswers(this.props.quest.sorted_answers)

    positionAnswers = () => questModel.positionAnswers(this.props.quest.sorted_answers)

    sortedAnswers = () => questModel.sortedQuestAnswers(this.props.quest)

    filterAnswers = answers => {
        if (!answers) return []

        let filteredAnswers
        const nonNilAnswers = answers.filter(Boolean)
        if (this.state.filter === 'archive') {
            filteredAnswers = nonNilAnswers.filter(ans => ans?.archive)
        } else if (this.state.filter === 'all') {
            filteredAnswers = nonNilAnswers
        } else if (!this.state.filter || this.state.filter === 'none') {
            filteredAnswers = nonNilAnswers.filter(ans => !ans?.archive)
        } else {
            filteredAnswers = nonNilAnswers.filter(
                ans => ans.action_tags && ans.action_tags[this.state.filter],
            )
        }

        return filteredAnswers
    }

    displayAnswers = questArg => {
        const quest = questArg || this.props.quest
        // Safeguard when sorted_answers is not yet loaded
        //console.log('DISP ANSWERS', (quest.sorted_answers || []).map(a => [a.id, a.content, a.position]))

        let answers

        if (!this.state.showAll && this.state.collapseActivated) {
            //console.log('collapse vars', this.state.collapsePosition, this.state.answersShown)
            if (this.state.answersShown == 0) answers = []
            else if (!quest.default_sort_col || quest.default_sort_col == 'position') {
                let dispAns = this.filterAnswers(this.sortedAnswers())
                    .slice(-this.state.answersShown)
                    .filter(a => a.position > this.state.collapsePosition)
                // console.log('display by position', dispAns)
                answers = dispAns
            } else {
                let dispAns = this.filterAnswers(this.sortedAnswers())
                    .slice(0, this.state.answersShown)
                    .filter(a => a.position <= this.state.collapsePosition)
                //console.log('display by votes', dispAns)
                answers = dispAns
            }
        } else if (this.state.showAll) {
            answers = this.filterAnswers(this.sortedAnswers())
        } else if (
            !this.isSystemUser() &&
            lightweightStreamCardEnabled(!this.props.isActive) &&
            (!this.state.filter || this.state.filter === 'none')
        ) {
            // Keep the rendered lightweight-card rows identical to the geometry projection:
            // search matches and new-since-last-visit replies remain visible, while stale
            // "latest 3" filler replies do not mount below a title-only card.
            answers = this.filterAnswers(
                resolveQuestStreamPreviewAnswers(quest).concat(this.newSessionAnswers()),
            )
        } else if (quest.matching_answer_ids && quest.matching_answer_ids.length > 0) {
            answers = this.filterAnswers(this.matchingAnswers()?.concat(this.newSessionAnswers()))
        } else if (quest.defaut_sort_col === 'vote') {
            answers = this.filterAnswers(quest.sorted_answers).slice(
                0,
                this.SHOW_PREVIEW + this.state.answersShown,
            )
        } else {
            const filtered = this.filterAnswers(quest.sorted_answers)
            const len = filtered.length
            const lastCreated = filtered
                .sort((a, b) => a.created_at - b.created_at)
                .slice(len - this.SHOW_NEW - this.state.answersShown, len)
            answers = lastCreated.sort((a, b) => a.position - b.position)
        }

        // quote_main union: interleave the head's main-thread quotes with the
        // native replies, the whole list ordered by created date. No quotes →
        // the list (and its ordering) is exactly what it was.
        const quoteAnswers =
            this.props.isActive && this.state.quoteAnswers?.length
                ? this.state.quoteAnswers.filter(
                      qa =>
                          qa?.id &&
                          qa.id !== quest.parent?.id &&
                          !answers.some(a => a?.id === qa.id),
                  )
                : []
        if (quoteAnswers.length) {
            answers = [...answers, ...quoteAnswers].sort(
                (a, b) => new Date(a?.created_at).getTime() - new Date(b?.created_at).getTime(),
            )
        }

        // prepend title answer (quest.parent) to the list of answers
        let sortedAnswers = [quest.parent, ...answers]
        return sortedAnswers
    }

    newSessionAnswers = () => this.state.newSessionAnswers || []

    moreAnswers = () => {
        const sortedAnswerIds = this.props.quest?.sorted_answer_ids || []
        const sorted_answers = this.props.quest?.sorted_answers || []
        const filteredAnswers = this.filterAnswers(sorted_answers)
        //console.log('more answers', filteredAnswers, this.state.collapsePosition, this.props.quest.sorted_answers, this.displayAnswers())
        if (filteredAnswers) {
            const totalAnswerCount =
                this.props.quest?.__knovAnswerHydrationScope === 'stream-preview'
                    ? sortedAnswerIds.length
                    : filteredAnswers.length
            return Math.max(0, totalAnswerCount - (this.displayAnswers().length - 1))
        } else return 0
    }

    isDraft = () => this.props.quest.is_draft

    canCurrentUserReplyToQuest = () => {
        const quest = this.props.quest
        if (!questModel.canUserReplyInMainThread(quest, gon.currentUser)) return false
        const team = quest?.team
        if (!team) return true
        return questModel.canUserReplyToTeam(team, gon.currentUser)
    }

    // An open channel anyone may join, gating replies on membership (the thread's
    // members_only_replies, or the channel's own members reply rule): the
    // composer slot offers the join instead of a dead end.
    channelOpenToJoin = () => {
        const team = this.props.quest?.team
        return (
            !!gon.currentUser &&
            team?.public === true &&
            team?.standing_invitations_allowed === true
        )
    }

    canJoinChannelToReply = () => {
        const team = this.props.quest?.team
        if (!this.channelOpenToJoin()) return false
        return questModel.teamPermissionRule(team, team.who_can_reply_threads) === 'members'
    }

    renderChannelMembersOnlyGate = () => {
        if (this.channelOpenToJoin()) return this.renderJoinChannelToReply()
        const teamName = this.props.quest.team?.name || 'this channel'
        return (
            <div className={styles.loginLinkContainer} data-testid="channel-members-only-replies">
                <div className={styles.loginIcon}>
                    <i className="fa fa-lock" />
                </div>
                <div className={styles.loginLink} style={{ cursor: 'default' }}>
                    Only members of {teamName} can reply
                </div>
            </div>
        )
    }

    joinChannelToReply = () => this.joinChannel(this.props.quest?.team)

    // A non-member drafting a thread in an open channel that only members post
    // in: the thread would quietly become private, so the composer slot offers
    // the join instead. Returns that channel, or null.
    channelToJoinBeforePosting = () => {
        const quest = this.props.quest
        if (!this.isDraft() || !gon.currentUser) return null
        // Only the automatic fallback (quest.join_gate_team_id), never a Private
        // destination the user picked themselves.
        const teamId = quest?.join_gate_team_id
        if (quest?.team_id || !teamId) return null
        const store = useStore.getState()
        const team = [...(store.userStreams || []), ...(store.publicTeams || [])].find(
            candidate => String(candidate.id) === String(teamId),
        )
        return questModel.needsChannelJoinToPost(team, gon.currentUser) ? team : null
    }

    // The inline "Join X to post" opens the same join card as New thread; once
    // joined, the draft points back at the channel.
    joinChannelToPost = team =>
        requestChannelJoin(team, {
            reasonText: membersOnlyPostReason(team.name || 'this channel'),
            afterJoin: () => {
                const quest = this.props.quest
                Object.assign(quest, questModel.permsFromFilter(this.props.filter))
                useStore.getState().updateQuest({ ...quest })
                this.forceUpdate()
            },
        })

    renderJoinChannelToPost = team => (
        <div className={styles.loginLinkContainer} data-testid="channel-join-to-post">
            <div className={styles.loginIcon}>
                <i className="fa fa-user-plus" />
            </div>
            <button
                type="button"
                className={cn(styles.loginLink, styles.joinToReplyButton)}
                onClick={() => this.joinChannelToPost(team)}
            >
                {`Join ${team.name || 'this channel'} to post`}
            </button>
        </div>
    )

    // Joins +team+ and records the membership where the client's permission
    // checks read it. Resolves true on success.
    joinChannel = async team => {
        if (!team?.id || this.state.joiningChannelToReply) return false
        this.setState({ joiningChannelToReply: true })
        try {
            const res = await api.joinTeam(team.id)
            if (!res?.path) {
                useStore
                    .getState()
                    .showGlobalNotice(`Couldn't join ${team.name || 'this channel'}.`, {
                        variant: 'error',
                    })
                return false
            }
            recordChannelMembership(team)
            return true
        } finally {
            this.setState({ joiningChannelToReply: false })
        }
    }

    renderJoinChannelToReply = () => {
        const team = this.props.quest.team
        const joining = this.state.joiningChannelToReply
        return (
            <div className={styles.loginLinkContainer} data-testid="channel-join-to-reply">
                <div className={styles.loginIcon}>
                    <i className="fa fa-user-plus" />
                </div>
                <button
                    type="button"
                    className={cn(styles.loginLink, styles.joinToReplyButton)}
                    onClick={this.joinChannelToReply}
                    disabled={joining}
                >
                    {joining ? 'Joining…' : `Join ${team.name || 'this channel'} to reply`}
                </button>
            </div>
        )
    }

    // Composer-slot state for non-authors (and signed-out visitors) of a thread
    // whose author limited main-thread replies to themselves. One quiet line;
    // branches stay open, so point at that escape hatch. On an empty thread the
    // notice owns the title separator as its top border, like the composer would
    // — except in the bottom editor's pill, which floats clear of the title (the
    // title draws that line then).
    renderReplyPolicyNotice = () => {
        const quest = this.props.quest
        const isQuestEmpty = questModel.showUnarchivedAnswers(quest).length === 0
        return (
            <div
                className={cn(
                    styles.replyPolicyNotice,
                    isQuestEmpty &&
                        !this.shouldShowBottomEditor() &&
                        styles.replyPolicyNoticeEmptyThread,
                )}
                data-testid="thread-reply-locked-notice"
            >
                <Lock aria-hidden="true" />
                <span>
                    Only the author can post in the main thread. Anyone can reply in the branch.
                </span>
            </div>
        )
    }

    showNewAnswer = () => {
        const quest = this.props.quest

        // Active ordinal-wrapper and trusted market-card threads are intentionally
        // replyable even though their infrastructure parent is system-owned. Other
        // system threads keep their existing suppression.
        return shouldShowQuestReplyArea({
            isDraft: this.isDraft(),
            isSystem: Boolean(quest.parent?.user?.system || quest.is_system),
            leaderboardAnnouncement: Boolean(quest.parent?.leaderboard_announcement),
            marketCard: quest.parent?.market_card === true,
            radioPlay: this.isRadioPlayRoom(),
            mediaAnnouncement: this.isMediaAnnouncementRoom(),
            directMessage: isDirectMessageRoom(quest),
            messageType: quest.parent?.message_type,
        })
    }

    hidesMutedQuest = () => {
        const quest = this.props.quest
        return Boolean(
            !this.isSystemUser() &&
                quest?.user?.id &&
                isUserMuted(quest.user_id) &&
                !this.state.revealMuted,
        )
    }

    // A direct message reads as a chat: its composer is always the pinned pill.
    shouldShowBottomEditor = () =>
        (bottomEditorEnabled() || isDirectMessageQuest(this.props.quest)) &&
        !!this.props.isActive &&
        this.showNewAnswer() &&
        !this.hidesMutedQuest()

    syncBottomEditorPresence = () => {
        const mounted = this.shouldShowBottomEditor()
        if (mounted === this.bottomEditorPresence) return
        this.bottomEditorPresence = mounted
        this.props.panelContext?.setBottomEditorMounted?.(mounted)
    }

    isModerationQuestDelete = () =>
        perms.canDeleteQuest(gon.currentUser, this.props.quest) &&
        !perms.amQuestOwner(this.props.quest)

    deleteQuest = async (ev, moderationReason) => {
        ev?.preventDefault?.()
        ev?.stopPropagation?.()

        if (this.isModerationQuestDelete() && moderationReason === undefined) {
            this.closeQuestOptions()
            const { openConfirmTray } = useStore.getState().actions.trayActions
            openConfirmTray(
                "Delete another user's thread and notify them?",
                'Delete Thread',
                reason => this.deleteQuest(null, reason),
                {
                    title: 'Delete Thread',
                    cancelMessage: 'Cancel',
                    reasonInput: {
                        label: 'Reason for deletion',
                        placeholder: 'No reason given.',
                    },
                },
            )
            return
        }

        this.closeQuestOptions()
        await api.deleteQuest(
            this.props.quest.id,
            moderationReason !== undefined ? { reason: moderationReason } : {},
        )

        const { panel } = this.props.panelContext
        const filter = withDepth(panel?.filter)
        if (filter?.questId) {
            useStore.getState().panels.editPanel(panel.panelId, { empty: true, filter: {} })
            history.replaceState({}, '', '/')
        } else if (!(filter.starred || filter.history || filter.notifications)) {
            const filterKey = getQuestsQueryKey(filter)[1]
            cache.removeFromStream(filterKey, this.props.quest.id)
            removeQuestFromNaturalFeedSession(filterKey, this.props.quest.id)
        }
    }

    muteQuestUser = async ev => {
        this.closeQuestOptions()
        await api.muteUser(this.props.quest.user_id)

        const { panel } = this.props.panelContext
        const filter = withDepth(panel?.filter)

        if (filter?.questId) {
            useStore.getState().panels.editPanel(panel.panelId, { empty: true, filter: {} })
            history.replaceState({}, '', '/')
        } else if (!(filter.starred || filter.history || filter.notifications)) {
            const filterKey = getQuestsQueryKey(filter)[1]
            cache.removeFromStream(filterKey, this.props.quest.id)
            removeQuestFromNaturalFeedSession(filterKey, this.props.quest.id)
        }
    }

    tweet = providerId => {
        // Just send empty image data, backend will use actual answer images
        return api.tweetQuest(providerId, this.props.quest.id, {})
    }

    openDraftsModal = ev => {
        ev?.preventDefault?.()
        ev?.stopPropagation?.()
        this.newAnswer.current?.openDraftsModal?.()
    }

    tweetWithScreenshots = providerId => {
        // Old screenshot functionality - not used
        const answers = document.querySelectorAll(`#quest-${this.props.quest.id} .answer.comp`)
        let imageProms = []
        let imageData = {}

        for (let i = 0; i < answers.length; i++) {
            let answer = answers[i]
            /** @type {(value?: any) => void} */
            let resolveFunc = () => {}
            let df = new Promise((resolve, reject) => {
                resolveFunc = resolve
            })
            imageProms.push(df)

            const answerEl = /** @type {HTMLElement} */ (answer)
            const ansSel = /** @type {HTMLElement | null} */ (
                answer.querySelector('.web-quote-inner')
            )

            if (ansSel) {
                ansSel.style.marginLeft = '5px'
                let w = ansSel.offsetWidth
                let h = ansSel.offsetHeight
                let fs = window.getComputedStyle(ansSel).getPropertyValue('font-size')
                ansSel.style.width = 2 * w + 'px'
                ansSel.style.height = 2 * h + 'px'
                ansSel.style.fontSize = parseFloat(fs) * 2 + 'px'
                domtoimage
                    .toPng(ansSel, {
                        bgcolor: 'white',
                        quality: 0.99,
                    })
                    .then(function (data) {
                        ansSel.style.width = w + 'px'
                        ansSel.style.height = h + 'px'
                        ansSel.style.fontSize = fs
                        ansSel.style.marginLeft = '0'
                        imageData[answerEl.dataset.answerId] = data
                        resolveFunc?.()
                        return this
                    })
                    .catch(function (error) {
                        ansSel.style.width = w + 'px'
                        ansSel.style.height = h + 'px'
                        ansSel.style.fontSize = fs
                        ansSel.style.marginLeft = '0'
                        console.error('oops, something went wrong!', error)
                    })
            } else {
                imageData[answerEl.dataset.answerId] = '_no_selection_'
                resolveFunc?.()
            }
        }

        return Promise.all(imageProms).then(() => {
            return api.tweetQuest(providerId, this.props.quest.id, imageData)
        })
    }

    addAnswer = answer => {
        // The pin was for the message being answered; that reply is now posted,
        // so the composer stops quoting it rather than pointing at a stale
        // target. Nothing takes its place: the next quote is the next press.
        if (this.state.composerQuoteRequest) this.setState({ composerQuoteRequest: null })

        // This updates collapsed state.
        !this.isRankedQuest() &&
            this.setState(state => {
                return {
                    answersShown: (state.answersShown || 0) + 1,
                    newSessionAnswers: [...state.newSessionAnswers, answer],
                }
            })
    }

    insertAnswer = async answerId => {
        const quest = this.props.quest
        const newAnswer = answerModel.newAnswer(insertedAnswerPlaceholderParams(quest, answerId))
        // Setup side quest.
        const perms = questModel.getPerms(quest)
        const sideQuest = questModel.newQuest({
            ...perms,
            parent: /** @type {import('../../../types/answers').Answer} */ (newAnswer),
            is_draft: false,
        })

        cache.cacheQuest(sideQuest)
        cache.cacheAnswer({ ...newAnswer, child_quests: [{ id: sideQuest.id }] })

        api.createAnswer(newAnswer)
    }

    updateAnswer = answer => {
        //console.log('UPDATE ANSWER', answer)
        if (answer.id === this.props.quest?.parent?.id) {
            // Update parent answer.
            const newQuest = {
                ...this.props.quest,
                parent: answer,
            }
            useStore.getState().updateQuest(newQuest)
            // Update parent quest if it exists.
            if (answer.quest_id) {
                const newParentQuest = {
                    ...cache.getCachedQuest(answer.quest_id),
                    updated_at: new Date(),
                }
                useStore.getState().updateQuest(newParentQuest)
            }
        } else {
            // Update sorted answers.
            const ix = this.props.quest.sorted_answers.findIndex(ans => ans.id === answer.id)
            if (ix !== null) {
                const newAnswers = [...this.props.quest.sorted_answers]
                newAnswers[ix] = answer
                const newQuest = Object.assign({}, this.props.quest, { sorted_answers: newAnswers })
                useStore.getState().updateQuest(newQuest)
                // Update child quest if it exists.
                if (answer?.child_quests?.[0]) {
                    const newChildQuest = {
                        ...answer.child_quests[0],
                        updated_at: new Date(),
                        parent: answer,
                    }
                    useStore.getState().updateQuest(newChildQuest)
                }
            }
        }
    }

    removeAnswer = answerId => {
        const answerIdString = String(answerId)
        const newAnswers = (this.props.quest.sorted_answers || []).filter(
            ans => String(ans.id) !== answerIdString,
        )
        const newAnswerIds = this.props.quest.sorted_answer_ids?.filter(
            id => String(id) !== answerIdString,
        )
        const newQuest = {
            ...this.props.quest,
            updated_at: Date.now(),
            sorted_answers: newAnswers,
            sorted_answer_ids: newAnswerIds,
        }
        useStore.getState().updateQuest(newQuest)
        this.setState(state => ({
            newSessionAnswers: (state.newSessionAnswers || []).filter(
                ans => String(ans.id) !== answerIdString,
            ),
            answersShown: Math.max((state.answersShown || 0) - 1, 0),
        }))
    }

    showQuest = ev => {
        let questPath = this.props.quest.path
        if (!$(ev.target).hasClass('delete-quest') && !this.state.edit) {
            if (ev.metaKey) window.open(questPath, '_blank')
            else window.location.pathname = questPath
        }
    }

    setEdit = edit => this.setState({ parentAnswerEditMode: edit })

    clearSelection = () => {
        // Handle click if selection.
        const selection = window.getSelection()
        const hasTextSelection = selection.toString().length > 0
        let anchor = selection?.anchorNode
        let anchorInSelection
        if (anchor) {
            /** @type {Element | null} */
            let anchorElement =
                anchor.nodeType !== Node.ELEMENT_NODE
                    ? anchor.parentElement
                    : /** @type {Element} */ (anchor)
            anchorInSelection = !!anchorElement?.closest('.with-selection-comp')
        }

        // If there is a text selection we want to clear it instead of toggling selected answer.
        //console.log('hasSelection', selection, hasTextSelection, this.hasSelection)
        if (hasTextSelection || this.hasSelection) {
            if (!anchorInSelection || this.clickOutsideSelection) {
                selection.removeAllRanges()
            }
            this.clickOutsideSelection = null
            this.hasSelection = null
            return true
        } else if (isMobile && anchorInSelection && !selection.isCollapsed) {
            // Mobile doesn't reliably return toSting() or clears the selection sometime earlier? so just use anchor to check.
            // Cant use anchor for desktop bc it might be set even if no selection and we want to be able to click on text to navigate.
            this.clickOutsideSelection = null
            this.hasSelection = null
            return true
        } else return false
    }

    onClickTitle = ev => {
        ev.preventDefault()
        ev.stopPropagation()
        const { panel, isActive, slideToPanel, openRight } = this.props
        const panelId = panel.panelId

        // Can't usePanelContext but we can use the imperative api.
        const activeLeft = isActive && isPanelLeft(panelId)
        const activeCenter = isActive && isPanelCenter(panelId)
        const activeRight = isActive && isPanelRight(panelId)

        const quest = this.props.quest
        if (
            !shouldNavigateQuestTitle({
                isDraft: Boolean(quest.is_draft),
                isEditing: Boolean(this.state.parentAnswerEditMode),
                isSystem: Boolean(quest.parent?.user?.system),
                leaderboardAnnouncement: Boolean(quest.parent?.leaderboard_announcement),
                marketCard: quest.parent?.market_card === true,
                radioPlay: this.isRadioPlayRoom(),
                mediaAnnouncement: this.isMediaAnnouncementRoom(),
                directMessage: isDirectMessageRoom(quest),
                messageType: quest.parent?.message_type,
            })
        ) {
            return
        }
        if (this.clearSelection()) return

        if (activeCenter) {
            panel.shake()
            return
        } else if (activeLeft || activeRight) {
            slideToPanel()
        } else {
            const titleTarget = resolveQuestTitleNavigationTarget(quest)
            if (titleTarget && titleTarget.questId !== String(quest.id)) {
                openRight(titleTarget, { metricInputEvent: ev })
                return
            }

            const rightPanel = useStore.getState().panels.getPanelToRight(panelId)
            const rightQuestId = rightPanel?.filter?.questId
            const rightQuest = cache.getCachedQuest(rightQuestId)
            const rightParentId = rightQuest?.parent?.id

            if (rightParentId && rightParentId === quest.parent_id) {
                // Shake the right panel instead of removing it
                void rightPanel.requestAnswerReveal?.(rightParentId, {
                    questId: rightPanel.filter?.questId,
                    shake: true,
                    highlight: true,
                })

                if (isMobile || isPanelRight(panelId)) {
                    // Like openRight: a song playing in this post moves into the
                    // thread instead of docking when the slide pauses this panel.
                    // The thread's player takes it once the slide lands; claiming
                    // mid-slide would read as offscreen and dock it anyway.
                    const mediaHandoffKey = preparePanelMediaHandoffToAnswer(
                        panelId,
                        quest.parent_id,
                    )
                    if (mediaHandoffKey) {
                        const resume = () =>
                            resumePanelMediaHandoff(rightPanel.panelId, mediaHandoffKey)
                        getSwiperRef()?.current?.once?.('slideChangeTransitionEnd', resume)
                        setTimeout(resume, SWIPE_SPEED_SLOW + 150)
                    }
                    slideNext()
                }
            } else {
                // dm_chat: a conversation opens on its latest message, like a chat.
                const latestMessageId = isDmChatQuest(quest)
                    ? resolveDirectMessageLatestAnswer(quest)?.id
                    : null
                if (latestMessageId) {
                    openRight(
                        { questId: quest.id, answerId: latestMessageId },
                        { metricInputEvent: ev },
                    )
                    return
                }
                // Use orchestrator to insert/slide/highlight even when off-screen
                openRight(
                    { questId: quest.id, answerId: quest.parent_id },
                    { metricInputEvent: ev },
                )
            }
        }
    }

    onLayout = ev => {
        this.height = ev.nativeEvent.layout.height
    }

    expandAnswers = async ev => {
        ev?.preventDefault()
        ev?.stopPropagation()
        if (
            this.props.quest?.__knovAnswerHydrationScope === 'stream-preview' &&
            !(await this.reloadQuest({ reason: 'expand_stream_preview' }))
        )
            return
        this.setState({ showAll: true, collapsePosition: null, answersShown: 0 })
    }

    expandAnswersPartial = async ev => {
        ev?.preventDefault()
        ev?.stopPropagation()
        if (
            this.props.quest?.__knovAnswerHydrationScope === 'stream-preview' &&
            !(await this.reloadQuest({ reason: 'expand_stream_preview_partial' }))
        )
            return
        this.setState(state => ({ answersShown: state.answersShown + 3 }))
    }

    handleAnswerTextCollapsedChange = (answerId, textIsCollapsed) => {
        this.props.onAnswerTextCollapsedChange?.({
            questId: this.props.quest?.id,
            answerId,
            textIsCollapsed,
        })
    }

    showBranch = () => this.props.quest.parent?.quest_id

    showParentAnswer = () => {
        return !!this.props.quest.parent && this.props.quest.side_quest
    }

    showPostInspiration = () => {
        const answer = this.props.quest.parent
        return answer
    }

    isUnacted = () => {
        const quest = this.props.quest
        return (
            quest.has_acted === false &&
            quest.not_acted_answer_ids &&
            quest.not_acted_answer_ids.length === 0
        )
    }

    isSideQuest = () => this.props.quest.side_quest

    setAnswerFilter = filter => {
        this.setState({ filter })
    }

    showAnswerFilter = showAnswerFilter => {
        this.setState({ showAnswerFilter })
    }

    newAnswer = React.createRef()

    closeOptionsState = {
        showQuestOptions: false,
        showTypeOptions: false,
        showPermsOptions: false,
        showFilterDropdown: false,
        showSortColDropdown: false,
        showExtendedOptions: false,
    }

    closeQuestOptions = () => {
        this.setState({
            ...this.closeOptionsState,
            questOptionsPosition: null,
        })
    }

    setShowExtendedOptions = show => {
        this.setState({
            ...this.closeOptionsState,
            showQuestOptions: show,
            showExtendedOptions: show,
            ...(show ? {} : { questOptionsPosition: null }),
        })
    }

    setShowTypeOptions = show => {
        if (perms.amQuestOwner(this.props.quest))
            this.setState({
                ...this.closeOptionsState,
                showQuestOptions: show,
                showTypeOptions: show,
                ...(show ? {} : { questOptionsPosition: null }),
            })
        else return
        //alert('You do not have permission to change this quest type.')
    }

    setShowPermsOptions = show => {
        if (perms.amQuestOwner(this.props.quest))
            this.setState({
                ...this.closeOptionsState,
                showQuestOptions: this.isDraft() ? false : show,
                showPermsOptions: show,
                ...(show ? {} : { questOptionsPosition: null }),
            })
        else alert('You do not have permission to edit this thread.')
    }

    setShowFilterDropdown = show => {
        this.setState({
            ...this.closeOptionsState,
            showQuestOptions: show,
            showFilterDropdown: show,
            ...(show ? {} : { questOptionsPosition: null }),
        })
    }

    setShowSortColDropdown = show => {
        this.setState({
            ...this.closeOptionsState,
            showQuestOptions: show,
            showSortColDropdown: show,
            ...(show ? {} : { questOptionsPosition: null }),
        })
    }

    isPinned = () => {
        const quest = getCachedQuest(this.props.quest?.id) || this.props.quest
        const team = quest.team
        return team && quest.id === team.quest_id
    }

    isCurrentUserProfileStream = () => {
        const filterUserId = this.props.filter?.user
        return (
            !!gon.currentUser &&
            !!filterUserId &&
            String(filterUserId) === String(gon.currentUser.id)
        )
    }

    isPinnedToProfile = () => {
        const pinnedProfileQuestId = gon.currentUser?.pinned_quest_id
        return (
            this.isCurrentUserProfileStream() &&
            !!pinnedProfileQuestId &&
            String(pinnedProfileQuestId) === String(this.props.quest?.id)
        )
    }

    refreshCurrentQuestStream = async () => {
        const keyedFilter = withDepth(this.props.filter || {})
        const queryKey = getQuestsQueryKey(keyedFilter)
        resetNaturalFeedSessionSnapshot(String(queryKey[1]))
        await queryClient.invalidateQueries({ queryKey, exact: true })
    }

    pinToTeam = () => {
        const quest = this.props.quest
        const team = quest.team
        if (team) {
            useStore.getState().pinQuestToTeam(team.id, quest)
        }
    }

    unpinFromTeam = () => {
        const quest = this.props.quest
        const team = quest.team
        if (team) {
            useStore.getState().unpinQuestFromTeam(team.id, quest)
        }
    }

    pinToProfile = async () => {
        const quest = this.props.quest
        const res = await api.pinQuest(quest.id)
        if (res?.ok) {
            gon.currentUser.pinned_quest_id = quest.id
            await this.refreshCurrentQuestStream()
        }
    }

    unpinFromProfile = async () => {
        const quest = this.props.quest
        const res = await api.unpinQuest(quest.id)
        if (res?.ok) {
            gon.currentUser.pinned_quest_id = null
            await this.refreshCurrentQuestStream()
        }
    }

    getPosition = (sortedArr, dragStartIdx, dragEndIdx) => {
        const dest = sortedArr[dragEndIdx]
        let out
        if (dragEndIdx == 0) {
            out = sortedArr[0].position - 1
        } else if (dragEndIdx == sortedArr.length - 1) {
            out = sortedArr[sortedArr.length - 1].position + 1
        } else {
            const cur = sortedArr[dragEndIdx]
            const prev = sortedArr[dragEndIdx - 1]
            const next = sortedArr[dragEndIdx + 1]
            if (dragEndIdx > dragStartIdx) {
                out = cur?.position + ((next?.position || 0) - cur?.position) / 2
            } else {
                out = (prev?.position || 0) + (cur?.position - (prev?.position || 0)) / 2
            }
        }
        return out
    }

    moveAnswer = async (dragStartIdx, dragEndIdx) => {
        let sortedAnswers = [...this.displayAnswers()]
        const currentQuestId = this.props?.quest?.id

        if (dragStartIdx == 0 || dragEndIdx == 0) {
            // doing a title swap
            let origTitleAnswer = sortedAnswers[0]
            let firstNonTitleAnswer = sortedAnswers?.[1]
            const draggedAnswer = sortedAnswers[dragStartIdx]

            // api.swapAnswer(origTitleAnswer?.id, firstNonTitleAnswer?.id, { optimistic: true })

            if (dragEndIdx == 0) {
                // dragging answer into title slot

                // lock quest in cache to prevent race condition re-renders
                useStore.getState().lockQuest(draggedAnswer?.quest_id)

                // then swap it into the title slot
                const swapResult = await api.swapAnswer(draggedAnswer?.id, origTitleAnswer?.id)

                // Place the old title back into the dragged answer's original slot (swap semantics).
                let posUpdateResult = null
                try {
                    if (origTitleAnswer?.id && draggedAnswer?.position != null) {
                        posUpdateResult = await api.updateAnswer(origTitleAnswer.id, {
                            position: draggedAnswer.position,
                        })
                    }
                } catch {}

                useStore.getState().unlockQuest(draggedAnswer?.quest_id)

                cache.cacheQuests(swapResult?.updated_quests)
                if (posUpdateResult) cache.cacheAnswer(posUpdateResult)

                if (this.props?.selectedAnswer?.id == origTitleAnswer?.id) {
                    // TODO PANEL REFACTOR
                    // Highlight Selected Answer
                }
            } else if (dragStartIdx == 0) {
                // dragging answer out of title slot
                // Swap the current title with the answer we dropped on, so the drop target becomes title.
                const clampedIdx = Math.min(
                    Math.max(1, dragEndIdx),
                    (sortedAnswers?.length || 2) - 1,
                )
                const targetAnswer = sortedAnswers?.[clampedIdx] || firstNonTitleAnswer
                if (!targetAnswer) return

                useStore.getState().lockQuest(targetAnswer?.quest_id)

                const swapResult = await api.swapAnswer(origTitleAnswer?.id, targetAnswer?.id)

                // After the swap, move the old title into the target answer's original slot.
                // Using the target's previous position yields the most intuitive "swap" behavior.
                const newPosition =
                    targetAnswer?.position != null
                        ? targetAnswer.position
                        : this.getPosition(
                              sortedAnswers.slice(1),
                              0,
                              clampedIdx - 1 < 0 ? 0 : clampedIdx - 1,
                          )

                const posUpdateResult = await api.updateAnswer(draggedAnswer?.id, {
                    position: newPosition,
                })

                useStore.getState().unlockQuest(targetAnswer?.quest_id)

                cache.cacheQuests(swapResult?.updated_quests)
                cache.cacheAnswer(posUpdateResult)

                if (this.props?.selectedAnswer?.id == draggedAnswer?.id) {
                    // TODO PANEL REFACTOR
                    // Highlight Selected Answer
                }
            }
        } else {
            // just a normal answer move
            const srcAnswer = sortedAnswers?.[dragStartIdx]

            // slice answers array and update indexes to match to account for
            // title answer
            const newPosition = this.getPosition(
                sortedAnswers.slice(1),
                dragStartIdx - 1,
                dragEndIdx - 1,
            )
            api.updateAnswer(srcAnswer?.id, { position: newPosition }, { optimistic: true })
        }
    }

    ensureQuestPublished = async () => {
        const quest = this.props.quest
        if (!quest?.is_draft) return quest

        try {
            // Clear the draft from dedicated store
            draftAnswerStore.clearDraft(quest.id)

            const draftQuest = {
                ...quest,
                is_draft: false,
                created_at: quest.parent?.created_at || quest.created_at,
                updated_at: quest.parent?.updated_at || quest.updated_at,
                parent: quest.parent,
                isLocalRootQuest: true,
            }

            const apiQuest = await api.createQuest(draftQuest)
            const publishedQuest = apiQuest || draftQuest

            cache.cacheQuest(publishedQuest)
            clearPublishedNewThreadContext(
                this.props.panelContext?.panel,
                useStore.getState().panels.editPanel,
            )

            if (window.location?.pathname === '/new' && publishedQuest?.path) {
                history.pushState({}, null, publishedQuest.path)
            }

            return publishedQuest
        } catch (err) {
            console.error('Failed to publish quest before drag/drop', err)
            return quest
        }
    }

    moveAnswerBetweenQuests = async (hoverIndex, answerId) => {
        const quest = await this.ensureQuestPublished()
        // Capture the source quest before we mutate the answer.
        // This lets us optimistically update both quests' cached answer lists so the UI doesn't "lose" the answer.
        const fromQuestId = (() => {
            try {
                return cache.getCachedAnswer(answerId)?.quest_id
            } catch {
                return null
            }
        })()
        // account for title answer
        const [title, ...sortedAnswers] = [...this.displayAnswers(quest)]
        const numOfSlots = sortedAnswers.length

        // `hoverIndex` is an index into the target quest list INCLUDING the title at index 0.
        // We convert it into an insertion index into `sortedAnswers` (which excludes the title),
        // allowing insertIx === numOfSlots to represent "append at end".
        let insertIx = Number(hoverIndex) - 1
        if (!Number.isFinite(insertIx)) insertIx = 0
        insertIx = Math.max(0, Math.min(insertIx, numOfSlots))

        let newPos
        if (numOfSlots < 1) {
            // Sidequest only has a title answer
            newPos = title?.position + 1
        } else if (insertIx === 0) {
            newPos = sortedAnswers?.[0]?.position - 1
        } else if (insertIx >= numOfSlots) {
            newPos = sortedAnswers?.[numOfSlots - 1]?.position + 1
        } else {
            const prev = sortedAnswers?.[insertIx - 1]
            const next = sortedAnswers?.[insertIx]
            newPos = (prev?.position + next?.position) / 2
        }

        const srcAnswer = await api.updateAnswer(
            answerId,
            /** @type {Partial<import('../../../types/answers').Answer> & {skip_notifications?: boolean}} */ ({
                position: newPos,
                quest_id: quest.id,
                skip_notifications: true,
            }),
            { optimistic: true },
        )

        // Optimistic cache update (target + source quest) so the dropped answer remains visible immediately.
        // Without this, the list can briefly re-render from stale quest data and the moved answer "disappears"
        // until a refresh/refetch happens.
        try {
            const movedId = String(answerId)
            const toQuestId = String(quest.id)

            // Update source quest: remove answer
            if (fromQuestId && String(fromQuestId) !== toQuestId) {
                const fromQuest = cache.getCachedQuest(fromQuestId)
                if (fromQuest) {
                    const nextFromAnswers = (fromQuest.sorted_answers || []).filter(
                        a => String(a?.id) !== movedId,
                    )
                    const nextFromIds = Array.isArray(fromQuest.sorted_answer_ids)
                        ? fromQuest.sorted_answer_ids.filter(id => String(id) !== movedId)
                        : fromQuest.sorted_answer_ids

                    cache.cacheQuest({
                        ...fromQuest,
                        sorted_answers: nextFromAnswers,
                        ...(Array.isArray(fromQuest.sorted_answer_ids) && {
                            sorted_answer_ids: nextFromIds,
                        }),
                    })
                }
            }

            // Update target quest: insert answer at hovered index (after title)
            const toQuest = cache.getCachedQuest(quest.id) || quest
            if (toQuest) {
                const nextToAnswers = [...(toQuest.sorted_answers || [])].filter(
                    a => String(a?.id) !== movedId,
                )

                // Ensure we don't insert into the title slot in the optimistic UI;
                // if hoverIndex === 0, the swap logic below will handle title reordering.
                let insertIx = Math.max(1, Number(hoverIndex) || 0)
                insertIx = Math.min(insertIx, nextToAnswers.length)

                if (srcAnswer) {
                    nextToAnswers.splice(insertIx, 0, srcAnswer)
                }

                const nextToIds = Array.isArray(toQuest.sorted_answer_ids)
                    ? nextToAnswers.map(a => a?.id).filter(Boolean)
                    : toQuest.sorted_answer_ids

                cache.cacheQuest({
                    ...toQuest,
                    sorted_answers: nextToAnswers,
                    ...(Array.isArray(toQuest.sorted_answer_ids) && {
                        sorted_answer_ids: nextToIds,
                    }),
                })
            }
        } catch (e) {
            // Best-effort only; fall back to server data/refetch.
        }

        if (hoverIndex == 0) {
            // user is dragging an answer into quest's title slot, so swap the
            // tgt quest's first non-title answer with with the answer being
            // dragged
            const tgtAnswer = cache.getCachedQuest(quest?.id)?.sorted_answers?.[1]

            if (srcAnswer?.id && tgtAnswer?.id) {
                await api.swapAnswer(srcAnswer.id, tgtAnswer.id, { optimistic: true })
            }
        }
        // NOTE: sadly without this setTimeout() zustand does not re-render
        // after a move between quests, I am not yet sure why so to workaround
        // issue an  empty quest update on the next tick
        setTimeout(() => {
            cache.updateCachedQuest(quest.id, {})
        }, 0)
    }

    resetOtherQuest = async id => {
        queryClient.refetchQueries({ queryKey: ['quest', id], exact: true })
    }

    appendAnswerToQuest = async answerId => {
        const quest = await this.ensureQuestPublished()
        const answers = this.displayAnswers(quest) || []
        const lastAnswer = answers[answers.length - 1]
        const basePosition = lastAnswer?.position || quest?.parent?.position || Date.now() / 1000

        /** @type {Partial<import('../../../types/answers').Answer> & {skip_notifications?: boolean}} */
        const updatePayload = {
            position: basePosition + 1,
            quest_id: quest.id,
            skip_notifications: true,
        }
        await api.updateAnswer(answerId, updatePayload)

        const answer = cache.getCachedAnswer(answerId)
        if (answer)
            cache.cacheQuest({
                ...quest,
                sorted_answers: [...(quest.sorted_answers || []), answer],
            })
    }

    // A stream card's breadcrumb strip and its head post are two halves of one
    // hover surface, but siblings in the DOM (quest.module.scss pairs them the
    // other way round). The head post owns the hover state (Answer.state.hover);
    // feed the strip's enter/leave into it via pairedHover so the card lights
    // from the crumb down. Stream cards only: in a thread panel the strip is the
    // panel's parent-crumb header. Gated like Answer.onMouseEnter, so a tap on a
    // phone does not re-render the card for a value the post then ignores.
    // The value goes straight to the head post (registerHeadPairedHover) rather than
    // through Quest state, which re-rendered every reply in the card on each crossing.
    crumbHover = false

    headPairedHover = null

    registerHeadPairedHover = listener => {
        this.headPairedHover = listener
        if (this.crumbHover) listener(true)
        return () => {
            if (this.headPairedHover === listener) this.headPairedHover = null
        }
    }

    onCrumbHover = hovered => {
        if (this.props.isActive || isMobile) return
        this.crumbHover = hovered
        this.headPairedHover?.(hovered)
    }

    // The head post registers its own title click (Answer.onClickTitle) so the
    // strip goes through the same door as the post body — the controls-popup
    // and edit guards and the CLICK_ANSWER_GATE event — and falls back to the
    // bare navigation while the post is unmounted (AnswerInView placeholder).
    headClick = null

    registerHeadClick = handler => {
        this.headClick = handler
        return () => {
            if (this.headClick === handler) this.headClick = null
        }
    }

    onCrumbRowClick = ev => (this.headClick || this.onClickTitle)(ev)

    isRankedQuest = () => this.props.quest.default_sort_col === 'vote'

    // Generate and cache a "new answer (draft)", to write in. This is diffirent than a draft answer for existing published answers.
    ensureNewAnswer = () => {
        const quest = this.props.quest

        // Check draft store first - get ID and look up from cache
        const draftId = draftAnswerStore.getDraftId(quest.id)
        /** @type {import('../../../types/answers').AnswerOrDraft | null} */
        let newAnswer = draftId ? getCachedAnswer(draftId) : null

        if (!newAnswer) {
            newAnswer = answerModel.newAnswer({
                quest_id: quest.id,
                space_id: quest.space_id,
                is_draft: true,
            })
            // Setup side quest for instant local branching
            const perms = questModel.getPerms(quest)
            /** @type {Partial<import('../../../types/quests').Quest> & {isLocalChildQuest?: boolean, grand_parent_id?: string, grand_parent?: object}} */
            const sideQuestParams = {
                ...perms,
                parent_id: newAnswer.id,
                is_draft: false,
                grand_parent_id: quest?.parent_id,
                grand_parent: quest?.parent,
                isLocalChildQuest: true,
            }
            const sideQuest = questModel.newQuest(sideQuestParams)
            newAnswer.child_quests = [{ id: sideQuest.id }]

            // Store draft ID in store, cache the answer separately
            draftAnswerStore.setDraft(quest.id, newAnswer.id)

            // Cache the draft answer and sidequest (but NOT on the quest)
            cache.cacheAnswer(newAnswer)
            cache.cacheQuest(sideQuest)
        }
        return newAnswer
    }

    getNewAnswer = () => {
        const quest = this.props.quest
        if (quest.is_draft) return quest.parent

        // Get draft from cache via store ID
        const draftId = draftAnswerStore.getDraftId(quest.id)
        return draftId ? getCachedAnswer(draftId) : null
    }

    getPanel = () => useStore.getState().panels.getPanel(this.props.panelId)
    isActive = () => this.getPanel().filter?.questId

    // Treechat Radio play rooms are authored by the system user but are
    // ordinary public rooms — people chat and reply in them. Without this they
    // inherit notification chrome, which renders no composer at all.
    isRadioPlayRoom = () => Boolean(this.props.quest?.parent?.action_tags?.radio_play)

    isMediaAnnouncementRoom = () =>
        Boolean(this.props.quest?.parent?.action_tags?.media_announcement)

    directMessagePlaceholder = () =>
        directMessageComposerPlaceholder(this.props.quest, gon.currentUser?.id)

    // The placeholder names the other person, whose record can reach the user
    // cache after this renders (a new conversation has nothing from them), so
    // follow their cache entry and render again when it lands or changes.
    syncDirectMessageCounterpart = () => {
        const counterpartId = directMessageCounterpartId(this.props.quest, gon.currentUser?.id)
        if (counterpartId === this.directMessageCounterpartId) return

        this.unsubscribeDirectMessageCounterpart?.()
        this.directMessageCounterpartId = counterpartId
        this.unsubscribeDirectMessageCounterpart = subscribeToDirectMessageCounterpart(
            this.props.quest,
            gon.currentUser?.id,
            () => this.forceUpdate(),
        )
    }

    // A direct message is system-owned so neither side owns it, but it is a
    // conversation, not a notification card.
    isSystemUser = () =>
        !this.isRadioPlayRoom() &&
        !this.isMediaAnnouncementRoom() &&
        !isDirectMessageRoom(this.props.quest) &&
        (this.props.quest.is_system ||
            this.props.quest?.parent?.user?.system ||
            this.props.quest.user_id === gon.SYSTEM_USER)

    // One reason label, two placements: desktop keeps it as an eyebrow above the card frame,
    // full-bleed mobile renders it inside the frame (an eyebrow in the seam between
    // edge-to-edge cards reads as belonging to neither card). CSS toggles which one shows.
    renderReasonLabel = (reasonLabel, containerClass, notificationMessage) => {
        const Glyph = reasonLabelGlyph(reasonLabel, notificationMessage)

        return (
            <div className={containerClass} style={{ height: QUEST_STREAM_REASON_LABEL_CHROME_PX }}>
                {Glyph && (
                    <span className={styles.reasonLabelGlyph} aria-hidden="true">
                        <Glyph size={12} />
                    </span>
                )}
                <span className={styles.reasonLabelText} title={reasonLabel}>
                    {reasonLabel}
                </span>
            </div>
        )
    }

    renderQuestOptionsPopover = (quest, answerFilterOptions) => {
        if (!this.state.showQuestOptions) return null

        const position = this.state.questOptionsPosition || this.getQuestOptionsPosition()
        if (!position) return null

        return createPortal(
            <div
                className={styles.questOptionsBackdrop}
                onMouseDown={this.closeQuestOptions}
                onTouchStart={this.closeQuestOptions}
            >
                <div
                    className={styles.questOptionsPopover}
                    style={{
                        top: `${position.top}px`,
                        left: `${position.left}px`,
                        width: `${position.width}px`,
                        maxHeight: `${position.maxHeight}px`,
                    }}
                    onMouseDown={ev => ev.stopPropagation()}
                    onTouchStart={ev => ev.stopPropagation()}
                >
                    <QuestOptions
                        panel={this.props.panel}
                        quest={quest}
                        filter={this.props.filter}
                        questPublic={this.state.questPublic}
                        questTeam={this.state.questTeam}
                        userTeams={gon.currentUser ? gon.currentUser.space_teams : null}
                        setQuestState={questState => this.setState(questState)}
                        answerFilter={this.state.filter || 'none'}
                        answerFilterOptions={answerFilterOptions}
                        deleteQuest={this.deleteQuest}
                        muteQuestUser={this.muteQuestUser}
                        tweet={this.tweet}
                        showAnswerFilter={this.showAnswerFilter}
                        setAnswerFilter={this.setAnswerFilter}
                        showPermsOptions={this.state.showPermsOptions}
                        showFilterDropdown={this.state.showFilterDropdown}
                        showSortColDropdown={this.state.showSortColDropdown}
                        showExtendedOptions={this.state.showExtendedOptions}
                        showTypeOptions={this.state.showTypeOptions}
                        reloadQuest={this.reloadQuest}
                        closeQuestOptions={this.closeQuestOptions}
                    />
                </div>
            </div>,
            document.body,
        )
    }

    renderDraftPermsPopover = quest => {
        if (!this.isDraft() || this.props.inlineCompactComposer || !this.state.showPermsOptions)
            return null
        if (typeof document === 'undefined') return null

        const position = this.state.questOptionsPosition || this.getDraftPermsPosition()
        if (!position) return null

        return createPortal(
            <div className={styles.questOptionsBackdrop} onClick={this.closeQuestOptions}>
                <div
                    className={cn(styles.questOptionsPopover, styles.draftPermsPopover)}
                    style={{
                        top: `${position.top}px`,
                        left: `${position.left}px`,
                        width: `${position.width}px`,
                        maxHeight: `${position.maxHeight}px`,
                    }}
                    onMouseDown={ev => ev.stopPropagation()}
                    onTouchStart={ev => ev.stopPropagation()}
                    onClick={ev => ev.stopPropagation()}
                >
                    <PermsOptions quest={quest} close={this.closeQuestOptions} showHeader />
                </div>
            </div>,
            document.body,
        )
    }

    render() {
        const { isActive, activeMiddle } = this.props
        const quest = this.props.quest

        // >>> Hydration issue detection: warn if quest data is missing or incomplete
        if (!quest) {
            console.warn(
                '>>> Quest.render: quest prop is null/undefined - hydration issue detected',
            )
            return null
        }
        if (!quest.id) {
            console.warn('>>> Quest.render: quest.id is missing - hydration issue detected', {
                quest,
            })
        }

        // [[ Learn Knov Data Model ]].
        // quest.parent is the title answer ie. head of the quest, w/ quest.sorted_answers being the tail.
        // When we branch from an answer, the answer becomes the parent or title or head of the branched quest (side quest).
        const parent = quest.parent

        // Check if quest owner is muted (but not if it's a system user)
        if (this.hidesMutedQuest()) {
            return (
                <div className={cn(styles.questComp)} data-qa-scroll-quest-frame="true">
                    <MutedContentPlaceholder
                        userName={quest.parent?.user?.name}
                        userId={quest.user_id}
                        variant="full"
                        onReveal={() => this.setState({ revealMuted: true })}
                    />
                </div>
            )
        }

        //console.log('QUEST RENDERING', quest.id, quest)

        const isEmpty =
            this.props.quest.sorted_answers && this.props.quest.sorted_answers.length == 0
        const emptyClass = isEmpty ? 'empty' : ''
        const actedClass = this.isUnacted() ? 'unacted' : ''
        const mobileClass = isMobile ? 'is-mobile' : ''

        const systemUser = this.isSystemUser()
        const systemUserStyles = systemUser ? styles.systemUser : null
        // A stream card, as opposed to the panel's own (active) thread.
        const isCard = !this.props.isActive

        const moreAnswers = this.moreAnswers()
        const showStats = moreAnswers > 0
        const showStatsBottom = showStats && this.isRankedQuest()
        const showStatsTop = showStats && !showStatsBottom
        let statsBorderStyle
        //if (showStatsBottom || this.displayAnswers()?.length === 1) statsBorderStyle = expandStyles.statsBottomBorder
        if (showStatsBottom && this.displayAnswers()?.length > 1)
            statsBorderStyle = expandStyles.statsTopBorder
        //const newAnswerBorderStyle = showStatsBottom
        const isActiveRight = isActive && isPanelRight(this.props.panelContext?.panelId)
        const sideQuestParentButtonStyle = isActiveRight ? styles.sideQuestParentButton : null
        const isPinnedToProfile = this.isPinnedToProfile()
        const isPinnedToTeam = !!quest.team && this.isPinned()
        const isPinnedThread = this.isCurrentUserProfileStream()
            ? isPinnedToProfile
            : isPinnedToTeam
        const pinTip = this.isCurrentUserProfileStream()
            ? 'Pinned to your profile'
            : quest.team
            ? `Pinned to ${quest.team.name}`
            : 'Pinned'

        const answerFilterCallback = val => this.setAnswerFilter(val)

        let answerFilterOptions = [
            {
                type: 'icon',
                name: 'NO FILTER',
                value: 'none',
                desc: '',
                logo: 'fa fa-filter',
                closeOnClick: true,
                callback: answerFilterCallback,
            },
            {
                type: 'icon',
                name: 'ARCHIVED',
                value: 'archive',
                desc: 'Show archived posts.',
                logo: 'fa fa-folder',
                closeOnClick: true,
                callback: answerFilterCallback,
            },
            {
                type: 'icon',
                name: 'ALL',
                value: 'all',
                desc: 'Show all posts.',
                logo: 'fa fa-eye',
                closeOnClick: true,
                callback: answerFilterCallback,
            },
        ]

        let customAnswerFilterOptions =
            quest.sorted_answers &&
            Array.from(
                new Set(
                    quest.sorted_answers
                        ?.map(el => el?.action_tags && Object.keys(el.action_tags))
                        ?.flat(),
                ),
            )
                ?.filter(Boolean) // Convert to array and remove empty strings.
                ?.map(tag => {
                    return {
                        type: 'icon',
                        name: tag.toUpperCase(),
                        value: tag,
                        desc: `Show posts with !${tag}`,
                        logo: 'fa fa-exclamation',
                        closeOnClick: true,
                        callback: answerFilterCallback,
                    }
                })

        if (false && customAnswerFilterOptions) {
            answerFilterOptions = answerFilterOptions.concat(customAnswerFilterOptions)
        }

        const isBlog = this.props.quest.blog

        const titleAnswerProps = {
            isTitle: true,
            isActive: this.props.isActive,
            panel: this.props.panel,
            showInsert: false,
            showControls: true,
            showTopControls: false,
            showVotes: true,
            selectable: true,
            blog: this.props.quest.blog,
            CONTROL_BUTTONS: CONTROL_BUTTONS,
            outsideEdit: true,
            editMode: this.state.parentAnswerEditMode,
            setEdit: this.setEdit,
            parentEditor: this.parentAnswerRef,
            filter: this.props.filter,
            answerFilter: this.state.filter || 'none',
            updateAnswer: this.updateAnswer,
            registerHeadPairedHover: this.registerHeadPairedHover,
            registerHeadClick: this.registerHeadClick,

            onClickTitle: this.onClickTitle,

            setShowPermsOptions: this.setShowPermsOptions,
            showPermsOptions: this.state.showPermsOptions,

            setShowFilterDropdown: this.setShowFilterDropdown,
            showFilterDropdown: this.state.showFilterDropdown,

            setShowSortColDropdown: this.setShowSortColDropdown,
            showSortColDropdown: this.state.showSortColDropdown,

            setShowExtendedOptions: this.setShowExtendedOptions,
            showExtendedOptions: this.state.showExtendedOptions,
            deleteQuest: this.deleteQuest,
            muteQuestUser: this.muteQuestUser,
            reloadQuest: this.reloadQuest,
            tweet: this.tweet,

            collapseHandler: this.collapseHandler,
            showEmbedButton: this.props.showEmbedButton,
            titleSelected:
                useStore.getState().selectedAnswers[
                    useStore.getState().panels.getPanelToLeft(this.props.panelId)?.panelId
                ]?.answerId === quest.parent?.id,
        }

        const newAnswerContainerDesktopStyles =
            isMobile || this.displayAnswers()?.length === 1 || showStatsBottom
                ? null
                : styles.newAnswerContainerDesktop

        const newAnswer = this.getNewAnswer()

        const isBsv = perms.isPublic(quest)
        const showDraftPermsControl = this.isDraft() && !this.props.inlineCompactComposer
        const channelToJoinBeforePosting = this.channelToJoinBeforePosting()

        const titleSelected =
            useStore.getState().selectedAnswers[
                useStore.getState().panels.getPanelToLeft(this.props.panelId)?.panelId
            ]?.answerId === quest.parent?.id

        const hasAnswers = this.displayAnswers()?.length > 1
        // The composer the reply pill would quote into has to actually be on
        // screen for the in-place lane to exist; a stream card or a locked
        // thread still opens the modal. Adjacency is not required here — a
        // ranked thread's composer is reachable, just not the next row down.
        const inlineComposerMounted = this.inlineComposerMounted()
        // bottom_editor: the composer floats over the thread's end instead of
        // sitting against it, so there is no seam for the avatar-gutter
        // connector to join — neither half is drawn. The quote itself still
        // lands in place.
        const showBottomEditor = this.shouldShowBottomEditor()
        const composerConnectorId = showBottomEditor ? null : this.connectedComposerAnswerId()
        // Where the fixed composer renders: the panel's host at its foot. Null
        // for one frame at most, while the panel attaches it.
        const bottomEditorHost = this.props.panelContext?.bottomEditorHost || null
        const questOptionsPopover = this.renderQuestOptionsPopover(quest, answerFilterOptions)
        const draftPermsPopover = this.renderDraftPermsPopover(quest)
        const hideQuestHeader = !!this.props.hideQuestHeader && this.isDraft()
        // A direct message leads with its own letter instead of the crumb
        // strip: the hero when open, the letter strip on its Messages card,
        // where a "Direct message" pill would only repeat the tab. (The stream
        // height estimate already counts no crumb for its system head.)
        const showThreadCrumb =
            !systemUser && !this.isDraft() && !hideQuestHeader && !isDirectMessageRoom(quest)
        const showAncestorSpine =
            !!this.props.isActive &&
            !systemUser &&
            !this.isDraft() &&
            !hideQuestHeader &&
            questHasAncestorSpine(quest)
        const contextualReasonLabel = this.props.filter?.notifications
            ? quest.notification_reason_label
            : this.props.filter?.following
            ? quest.feed_reason_label
            : null
        const filterMatchReasonLabel = contextualReasonLabel
            ? null
            : quest.feed_card?.filter_match_label
        const reasonLabel = contextualReasonLabel || filterMatchReasonLabel
        const reasonLabelNotificationMessage = this.props.filter?.notifications
            ? quest.notification_context?.message
            : null

        // A direct message waiting on its message request: once there is a
        // message, the recipient's answers (or the sender's wait) take the
        // composer's place; before it, the sender writes their one message.
        const requestSide = directMessageRequestSide(quest, gon.currentUser?.id)
        const requestHasMessage = !!requestSide && directMessageRequestHasMessage(quest)

        const composerBlock = isActive && this.showNewAnswer() && (
            <div
                className={cn(styles.newAnswerPanel, showBottomEditor && styles.bottomEditorPanel)}
                data-panel-scroll-end-anchor={showBottomEditor ? undefined : 'true'}
                data-bottom-editor={showBottomEditor ? 'true' : undefined}
            >
                {requestSide === 'outgoing' && !requestHasMessage && (
                    <DirectMessageRequestHint quest={quest} />
                )}
                <div
                    className={cn(
                        styles.newAnswerContainer,
                        newAnswerContainerDesktopStyles,
                        !hasAnswers && styles.newAnswerContainerBorderTop,
                        showBottomEditor && styles.bottomEditorPill,
                        showBottomEditor && 'bottom-editor-pill',
                    )}
                    data-bottom-editor-pill={showBottomEditor ? 'true' : undefined}
                >
                    {requestHasMessage ? (
                        <DirectMessageRequestBar quest={quest} side={requestSide} />
                    ) : questModel.needsChannelJoinToReply(this.props.quest, gon.currentUser) ? (
                        this.renderChannelMembersOnlyGate()
                    ) : !questModel.canUserReplyInMainThread(this.props.quest, gon.currentUser) ? (
                        this.renderReplyPolicyNotice()
                    ) : gon.currentUser ? (
                        this.props.quest?.team && !this.canCurrentUserReplyToQuest() ? (
                            this.canJoinChannelToReply() ? (
                                this.renderJoinChannelToReply()
                            ) : (
                                <div className={styles.loginLinkContainer}>
                                    <div className={styles.loginIcon}>
                                        <i className="fa fa-lock" />
                                    </div>
                                    <div className={styles.loginLink} style={{ cursor: 'default' }}>
                                        You don’t have permission to reply in this channel
                                    </div>
                                </div>
                            )
                        ) : (
                            <NewAnswerDndWrapper
                                newAnswerRef={el => {
                                    // @ts-expect-error - createRef().current is readonly but we mutate it at runtime
                                    this.newAnswer.current = el
                                    this.props.newAnswerRef.current = el
                                    if (activeMiddle) assignActiveNewAnswerRef(el)
                                    else if (isActive) assignSideNewAnswerRef(el)
                                }}
                                focusNewAnswer={this.focusNewAnswer}
                                panel={this.props.panel}
                                quest={this.props.quest}
                                newAnswer={newAnswer}
                                user={gon.currentUser}
                                showUser={true}
                                showUsername={false}
                                autoQuoteAnswer={this.composerQuoteAnswer()}
                                autoQuoteRequestSeq={this.state.composerQuoteRequest?.seq || 0}
                                autoQuoteAdjacent={!!composerConnectorId}
                                onQuoteTargetChange={this.handleComposerQuoteTargetChange}
                                onQuoteDismiss={this.clearComposerQuoteRequest}
                                // bottom_editor: the pill rests as a single line
                                // and opens out when it is focused or a quote is
                                // sent into it, on a desktop as on a phone.
                                collapsibleComposer={showBottomEditor}
                                bottomEditor={showBottomEditor}
                                placeholder={this.directMessagePlaceholder()}
                                addAnswer={this.addAnswer}
                                removeAnswer={this.removeAnswer}
                                appendAnswerToQuest={this.appendAnswerToQuest}
                                moveAnswerBetweenQuests={this.moveAnswerBetweenQuests}
                                blog={isBlog}
                                active={this.props.isActive}
                                showThreadReplyPolicy
                            />
                        )
                    ) : (
                        <div className={styles.loginLinkContainer}>
                            <div className={styles.loginIcon}>
                                <i className="fa fa-user" />
                            </div>
                            <a
                                href="/signup"
                                onClick={e => {
                                    e.preventDefault()
                                    useStore
                                        .getState()
                                        .actions.modalActions.openAuthModal(
                                            'signup',
                                            'join_to_reply',
                                        )
                                }}
                                className={styles.loginLink}
                            >
                                Join to reply
                            </a>
                        </div>
                    )}
                </div>
            </div>
        )

        return (
            <div
                ref={this.containerRef}
                id={`quest-${this.props.quest.id}`}
                className={cn(
                    'quest comp',
                    mobileClass,
                    styles.questShell,
                    this.state.showQuestOptions && styles.questOptionsOpen,
                    systemUserStyles,
                )}
                data-quest={this.props.quest.id}
            >
                {!systemUser && isPinnedThread && (
                    <div
                        className={cn('pin pin-noti', styles.pinnedIndicator)}
                        {...buildHoverTooltipAnchorProps(
                            { content: pinTip },
                            { touchLayout: isMobile },
                        )}
                    >
                        <PinIcon size={12} />
                    </div>
                )}
                {reasonLabel &&
                    this.renderReasonLabel(
                        reasonLabel,
                        cn(
                            styles.notificationReasonLabel,
                            filterMatchReasonLabel && styles.filterMatchReasonLabel,
                        ),
                        reasonLabelNotificationMessage,
                    )}
                <div
                    className={cn(styles.questComp, systemUserStyles)}
                    data-qa-scroll-quest-frame="true"
                    data-bottom-editor-card={showBottomEditor ? 'true' : undefined}
                    // A stream card renders the breadcrumb and the title as two
                    // halves of one card, which is what lets a highlight cover
                    // both. The panel's own thread renders the same breadcrumb
                    // as its parent-crumb header, where a second flash reads as
                    // an unrelated element lighting up.
                    data-quest-card={isCard ? 'true' : undefined}
                >
                    {showAncestorSpine && <QuestAncestorSpine quest={quest} />}
                    {isCard && resolveDirectMessageLatestAnswer(quest) && (
                        <DirectMessageCardHeader quest={quest} onOpen={this.onClickTitle} />
                    )}
                    {showThreadCrumb && (
                        <ThinParent
                            quest={quest}
                            isBsv={isBsv}
                            hideAncestorCrumb={showAncestorSpine}
                            onHoverChange={this.onCrumbHover}
                            // Stream cards only: the strip is part of the card's
                            // click surface. Active threads keep the pill-only crumb.
                            onRowClick={isCard ? this.onCrumbRowClick : undefined}
                            // fixed_header: the panel's place bar already names
                            // the channel and parent, so the open thread drops it.
                            redundantWithHeader={!isCard && fixedHeaderEnabled()}
                            isCard={isCard}
                        />
                    )}
                    {!systemUser && (
                        <div className={cn(this.isDraft() && styles.streamHeaderContainer)}>
                            <div
                                className={cn(
                                    styles.questionContainer,
                                    systemUserStyles,
                                    false && titleSelected && styles.titleSelected,
                                    this.showBranch() && styles.branch,
                                    this.isDraft() && styles.draftQuestionContainer,
                                    `question-container ${emptyClass} ${mobileClass}`,
                                )}
                                onMouseDown={ev => {
                                    const hasSelection = window.getSelection().toString().length > 0
                                    //console.log('mousedown', hasSelection)
                                    // <WithSelection> prevents the event so this wont fire and wont be set.
                                    // We set this so we know to clear the selection in this.toggleSelectedAnswer()
                                    if (hasSelection) {
                                        // The selection exists on mousedown but gets blurred before the onClick in some scenarios, so we track it with a flag.
                                        this.hasSelection = hasSelection
                                        this.clickOutsideSelection = true
                                    }
                                }}
                                onTouchStart={ev => {
                                    const hasSelection = window.getSelection().toString().length > 0
                                    //console.log('touchstart', hasSelection)
                                    // <WithSelection> prevents the event so this wont fire and wont be set.
                                    // We set this so we know to clear the selection in this.toggleSelectedAnswer()
                                    if (hasSelection) {
                                        // The selection exists on mousedown but gets blurred before the onClick in some scenarios, so we track it with a flag.
                                        this.hasSelection = hasSelection
                                        this.clickOutsideSelection = true
                                    }
                                }}
                            >
                                <div className={`acted-noti ${actedClass}`} />

                                {this.isDraft() && (
                                    <>
                                        {showDraftPermsControl && (
                                            <div className={styles.draftPermsContainer}>
                                                <div ref={this.draftPermsRef}>
                                                    <Perms
                                                        quest={quest}
                                                        filter={this.props.filter}
                                                        panel={this.props.panel}
                                                        showPermsOptions={
                                                            this.state.showPermsOptions
                                                        }
                                                        setShowPermsOptions={
                                                            this.setShowPermsOptions
                                                        }
                                                        isBsv={isBsv}
                                                        isComposer
                                                    />
                                                </div>

                                                <div className={styles.draftLinksContainer}>
                                                    <button
                                                        type="button"
                                                        className={styles.draftLink}
                                                        onClick={this.openDraftsModal}
                                                    >
                                                        Drafts
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        {/* End anchor: a draft thread renders no answers and no
                                            reply area, so without this the panel gutter resolves
                                            no anchor and collapses to 0 — a tall attachment then
                                            pins the Post row under the floating New button. */}
                                        <div
                                            className={styles.newTitleContainer}
                                            data-panel-scroll-end-anchor="true"
                                        >
                                            {channelToJoinBeforePosting ? (
                                                this.renderJoinChannelToPost(
                                                    channelToJoinBeforePosting,
                                                )
                                            ) : (
                                                <NewAnswer
                                                    ref={el => {
                                                        // @ts-expect-error - createRef().current is readonly but we mutate it at runtime
                                                        this.newAnswer.current = el
                                                        // We need these global refs so that SearchHeader and PanelHeader can focus here.
                                                        if (activeMiddle)
                                                            assignActiveNewAnswerRef(el)
                                                        else if (isActive)
                                                            assignSideNewAnswerRef(el)
                                                    }}
                                                    focusNewAnswer={this.focusNewAnswer}
                                                    focusFirstReplyAfterPublish={
                                                        this.focusFirstReplyAfterPublish
                                                    }
                                                    noReplyFocusAfterPublish={
                                                        !!quest.no_reply_focus_after_publish
                                                    }
                                                    panel={this.props.panel}
                                                    quest={quest}
                                                    newAnswer={newAnswer}
                                                    user={quest.parent?.user}
                                                    showUsername={false}
                                                    showUser={false}
                                                    placeholder={
                                                        quest.composer_placeholder ||
                                                        'Start thread: '
                                                    }
                                                    isTitle
                                                    setShowPermsOptions={this.setShowPermsOptions}
                                                    showPermsOptions={this.state.showPermsOptions}
                                                    // The props below cause an infinite loop.
                                                    filter={this.props.filter}
                                                    active={this.props.isActive}
                                                    onQuestPublished={this.props.onQuestPublished}
                                                    keepInlineAfterPublish={
                                                        this.props.keepInlineAfterPublish
                                                    }
                                                    inlineCollapseBoundaryRef={this.containerRef}
                                                    inlineCompactComposer={
                                                        this.props.inlineCompactComposer
                                                    }
                                                    inlineCompactAnimateOnMount={
                                                        this.props.inlineCompactAnimateOnMount
                                                    }
                                                />
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                    {questOptionsPopover}
                    {draftPermsPopover}
                    {(systemUser || !this.isDraft()) && (
                        <AnswerDndContainer
                            //key={quest.updated_at}
                            panelId={this.props.panelId}
                            displayAnswers={this.displayAnswers}
                            // quote_main: re-sync the local answer snapshot when
                            // the union's guest half arrives (constant [] when
                            // the flag is off — the dep never fires).
                            quoteAnswers={this.state.quoteAnswers}
                            query={this.props.query}
                            forbidDrop={!!this.state.collapsePosition}
                            titleAnswerProps={titleAnswerProps}
                            systemUser={systemUser}
                            panel={this.props.panel}
                            filter={this.props.filter}
                            isActive={this.props.isActive}
                            answerFilter={this.state.filter}
                            quest={this.props.quest}
                            removeAnswer={this.removeAnswer}
                            showInsert={!isBsv}
                            insertAnswer={this.insertAnswer}
                            updateAnswer={this.updateAnswer}
                            showBranching={this.props.panel === 'middle'}
                            showEmbedButton={this.props.showEmbedButton}
                            showAll={this.state.showAll}
                            moveAnswer={this.moveAnswer}
                            moveAnswerBetweenQuests={this.moveAnswerBetweenQuests}
                            resetOtherQuest={this.resetOtherQuest}
                            sideQuest={this.props.sideQuest}
                            blog={isBlog}
                            answersShown={this.state.answersShown}
                            showVotes
                            questIx={this.props.ix}
                            isBsv={isBsv}
                            setAnswerFilter={this.setAnswerFilter}
                            answerFilterOptions={answerFilterOptions}
                            showBranch={this.showBranch()}
                            onAnswerTextCollapsedChange={this.handleAnswerTextCollapsedChange}
                            expandedAnswerIds={this.props.expandedAnswerIds}
                            naturalFeedLayout={this.props.naturalFeedLayout}
                            naturalThreadLayout={this.props.naturalThreadLayout}
                            // The trailing row's half of the composer connector,
                            // and the door that puts a quote in the composer
                            // instead of opening the modal.
                            composerQuoteAnswerId={composerConnectorId}
                            onQuoteInPlace={
                                inlineComposerMounted ? this.quoteAnswerInComposer : undefined
                            }
                            // bottom_editor: the composer is pinned over the
                            // thread's end, on screen at every scroll position,
                            // so every row's reply lands in it — not only the
                            // trailing row's, which is the one row that has the
                            // in-flow composer as its neighbour.
                            composerAlwaysInReach={showBottomEditor}
                        />
                    )}
                    {isActive && showStatsBottom && (
                        <div className="quest-stats-container">
                            <ExpandAnswers
                                moreAnswers={this.moreAnswers()}
                                expandAnswers={this.expandAnswers}
                                expandAnswersPartial={this.expandAnswersPartial}
                                filter={this.props.filter}
                                direction="up"
                                contextStyles={statsBorderStyle}
                            />
                        </div>
                    )}
                    {showBottomEditor && (
                        <div
                            className={styles.bottomEditorReserve}
                            data-bottom-editor-reserve="true"
                            aria-hidden="true"
                        />
                    )}
                    {/* No end anchor under the fixed composer: the panel's gutter
                        then measures from the last reply row, so overscrolling
                        stops with that reply at the top rather than with the
                        whole thread scrolled away under the pill. */}
                    {showBottomEditor
                        ? // bottom_editor: fixed to the panel's foot, so it renders into
                          // the panel's host rather than at the card's end. Nothing
                          // renders until the host exists (one frame at most), which
                          // spares the composer a remount.
                          bottomEditorHost && createPortal(composerBlock, bottomEditorHost)
                        : composerBlock}
                </div>
            </div>
        )
    }
}

function ExpandAnswers(props) {
    //console.log('expand answers', props.numMatchingAnswers)
    const moreAnswers = props.moreAnswers
    //console.log('border styles', props.contextStyles)
    const showPartialExpand = moreAnswers > 3 && !props.filter.notifications
    const borderStyles = showPartialExpand ? expandStyles.redBorder : null

    const numMatches = props.numMatchingAnswers
    const baseBannerText = props.query ? 'Match' : 'New'
    const bannerText = props.query && numMatches > 1 ? 'Matches' : baseBannerText

    return (
        <div className={cn(expandStyles.expandControlsComp, borderStyles, props.contextStyles)}>
            {!!props.numMatchingAnswers && (
                <div className={expandStyles.newAnswerBannerContainer}>
                    <div className={expandStyles.newAnswerBanner}>
                        {numMatches} {bannerText}
                    </div>
                </div>
            )}

            {showPartialExpand && (
                <WithTooltip tip={`Expand next ${Math.min(moreAnswers, 3)} messages.`}>
                    <div
                        className={expandStyles.expandControl}
                        onClick={props.expandAnswersPartial}
                    >
                        Expand <strong>{Math.min(moreAnswers, 3)}</strong>
                    </div>
                </WithTooltip>
            )}

            <WithTooltip tip={`Expand ${moreAnswers} remaining messages.`}>
                <div className={cn(expandStyles.expandControl)} onClick={props.expandAnswers}>
                    <i className="fa fa-expand" />
                    {!showPartialExpand && <span className={expandStyles.expandLabel}>Expand</span>}
                    All <strong>{moreAnswers}</strong>
                </div>
            </WithTooltip>
        </div>
    )
}

export default Connector(stateSelector, () => ({
    insertLeft: useInsertLeft(),
    openRight: useOpenRight().openRight,
    slideToPanel: useSlideToPanel(),
    panelContext: usePanelContext(),
}))(
    React.forwardRef((props, ref) => (
        <ErrorBoundary label="Quest">
            <Quest ref={ref} {...props} />
        </ErrorBoundary>
    )),
)
